module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_timo-kekale_A4.f61707b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_timo-kekale_A4.pdf
// module id = sPx2
// module chunks = 22